// app/javascript/controllers/global_drawer_trigger_controller.js
// Trigger controller for opening the global drawer with dynamic content
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    src: String,
    height: String
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

      // Check if this element is actually visible before dispatching the event
      // This prevents hidden duplicate buttons (e.g., in other viewer tabs) from triggering
      const rect = this.element.getBoundingClientRect()
      const isVisible = rect.width > 0 && rect.height > 0 &&
          window.getComputedStyle(this.element).visibility !== 'hidden' &&
          window.getComputedStyle(this.element).display !== 'none'

      if (!isVisible) {
          return
      }

      // Additional check: if this button is inside an overlay (like image viewer),
      // ensure the overlay itself is actually open/visible
      const parentOverlay = this.element.closest('.hs-overlay')
      if (parentOverlay) {
          // Check if the overlay has the 'hidden' class or if it doesn't have the 'open' class
          const overlayHidden = parentOverlay.classList.contains('hidden')
          const overlayOpen = parentOverlay.classList.contains('open') || parentOverlay.classList.contains('opened')

          if (overlayHidden || !overlayOpen) {
              return
          }
      }

    const detail = {}
    
    if (this.hasSrcValue && this.srcValue) {
      detail.src = this.srcValue
    }
    
    if (this.hasHeightValue && this.heightValue) {
      detail.height = this.heightValue
    }

    document.dispatchEvent(new CustomEvent("global-drawer:open", {
      bubbles: true,
      detail
    }))

      document
          .querySelectorAll('[data-controller="dropdown"].dropdown--open')
          .forEach(el => {
              el.classList.remove("dropdown--open");
              const menu = el.querySelector('[data-dropdown-target="menu"]');
              if (menu) menu.classList.add("hidden");
          });
  }
}
